import { CurrencyResponse } from '@/modules/common/types/dto/currency.dto';
import { DepartmentResponse } from '@/modules/common/types/dto/response/department-response';
import { EmployeeRoleResponse } from '@/modules/common/types/dto/response/employee-role-response';
import { OpsiumUserShortResponse } from '@/modules/common/types/dto/response/opsium-user-response';
import { SeniorityResponse } from '@/modules/common/types/dto/response/seniority-response';
import { MembershipTypeResponse } from '@/modules/team/types/dto/response/membership-type-response';

/**
 * DTO enum for patch entity effect actions
 * Reuses the same enum as project conflicts
 */
export enum PatchEntityEffectActionDTO {
  DELETE = 'DELETE',
  CUT = 'CUT',
}

/**
 * DTO enum for team member status in conflicts
 */
export enum OpsiumUserStatusDTO {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

/**
 * DTO interface for patch entity effect
 * Describes the impact of a patch operation on an existing change
 */
export interface PatchEntityEffectDTO {
  action: PatchEntityEffectActionDTO;
  cutEffectiveStartDate: string | null;
  cutEffectiveEndDate: string | null;
}

/**
 * DTO interface for team member change data within conflict response
 * Contains all versioned fields for a team member at a specific time period
 */
export interface TeamMemberChangeDataDTO {
  id: number;
  seniority: SeniorityResponse | null;
  employeeRoleResponse: EmployeeRoleResponse | null;
  onDemand: boolean;
  totalWorkingMinutes: number;
  billableCapacity: number;
  department: DepartmentResponse | null;
  manager: OpsiumUserShortResponse | null;
  country: string | null;
  city: string | null;
  isHourlyRated: boolean;
  currency: CurrencyResponse;
  internalRate: number | null;
  externalRate: number | null;
  membershipType: MembershipTypeResponse | null;
  status: OpsiumUserStatusDTO;
  isManager: boolean;
  effectiveStartDate: string;
  effectiveEndDate: string | null;
}

/**
 * DTO interface for a single team member change conflict response
 * Response from GET /api/team/member-changes/conflicts
 */
export interface TeamMemberChangeConflictResponseDTO {
  change: TeamMemberChangeDataDTO;
  description: string;
  patchEffect: PatchEntityEffectDTO;
}
